///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.summary = abcsetup.rfq.summary || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.summary = {
    init: function () {
        abcsetup.setTitle('RFQ Bids Summary');

        this._initDatatables();
    },

    _initDatatables() {
        abcsetup.datatables.client_side.init($('table#bid-summary-table'), {
            bInfo: true,
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": -1,
            "order": [[1, "asc"]],
            "columnDefs": [{
                "targets": 5,
                "orderable": false
            }],
        });

        // Init bid refused datatable
        abcsetup.datatables.client_side.init($('#non-bid-table > table'), {
            bInfo: true,
            "responsive": true,
            "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
            "iDisplayLength": 10,
            "order": [[1, "asc"]],
        });
    },
}
